import { API } from 'apis';
import { getViaAuth, postViaAuth, responseValidator } from 'apis/api';
import { BankAccountStatementType, Order, PaginationList } from 'core/domain';
import toast from 'react-hot-toast';

export const getAllBankAccountStatements = async (
    setLoading: any,
    setData: any,
    page: number,
    itemsPerPageCount: number,
    query?: string,
) => {
    setLoading(true);
    await getViaAuth<PaginationList<BankAccountStatementType>>(
        API.bankAccountStatement.getAll + '/' + page + '/' + itemsPerPageCount + `${query || ''}`,
    ).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            if (response.data) {
                setData(response.data);
            }
        }
    });
};

export const getAllBankAccountStatementTypes = async (setLoading: any, setData: any) => {
    setLoading(true);
    await getViaAuth(API.enum.bankAccountStatementType).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            setData([{ id: -1, title: 'نوع' }, ...response.value]);
        }
    });
};

export const getAllBankAccountStatementChargeStatusTypes = async (setLoading: any, setData: any) => {
    setLoading(true);
    await getViaAuth(API.enum.bankAccountStatementChargeStatus).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            setData([{ id: -1, title: 'وضعیت شارژ' }, ...response.value]);
        }
    });
};

export const confirmAndPayoutBankAccountStatement = async (
    setLoading: any,
    data: any,
    setIsOpenFalse: any,
    getData: any,
) => {
    setLoading(true);
    postViaAuth<Order>(API.bankAccountStatement.confirmAndPayout, data).then((data) => {
        setLoading(false);
        if (responseValidator(data.status)) {
            toast.success('عملیات با موفقیت انجام شد.');
            setIsOpenFalse();
            getData();
        }
    });
};
